<template>
    <div class="card card-animated product-card">
        <a :href="'/' + pageSlug + '/' + type.slug" class="card-body sm-paddings">
            <h5 class="product-title">{{ type.name }}</h5>
            <div class="product-image" :class="{ unavailable: type.fullImage === null }"
                 :style="'background-image: url(' + (type.fullImage ? type.fullImage : './assets/images/icons/no-image.png') + ')'">
                <!--                <img :src="bike.image.image ? bike.image.fullImage : '/assets/images/icons/no-image.png'" :alt="bike.type_name">-->
            </div>
            <div class="product-pricing-grid" v-if="tableTimeOptions.length">
                <table>
                    <thead>
                    <tr>
                        <th></th>
                        <th v-for="o in tableTimeOptions" :key="o">{{ o | filterTimeOptionShortTitle }}</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr class="price-walk-in">
                        <td>Walk-In</td>
                        <td v-for="o in tableTimeOptions" :key="o" :class="{'none-decoration': !getTimeOptionById(o).price}">{{ (getTimeOptionById(o).price || '—')  | filterPrice(0) }}</td>
                    </tr>
                    <tr class="price-online">
                        <td>Online</td>
                        <td v-for="o in tableTimeOptions" :key="o">{{ (getTimeOptionById(o).final_price || '—')  | filterPrice }}</td>
                    </tr>
                    </tbody>
                </table>
            </div>
            <ul class="product-attributes">
                <li>
                    <span class="item-title">Available Accessories:</span>
                    <span class="item-value">{{ accessories ? 'Yes' : 'No' }}</span>
                </li>
            </ul>

        </a>

    </div>
</template>

<script>
import NumberSelector from "../elements/NumberSelector";
import FareHarborMixin from "../../../mixins/FareHarborMixin";
import {mapGetters} from "vuex";
export default {
    name: "TypeDetail",
    mixins: [FareHarborMixin],
    components: {NumberSelector},
    props: {
        type: {
            required: true
        },
        accessories: {
            type: Boolean,
            default: true
        },
        timeOption: {
            type: Array,
            default: []
        },
        typeRental: {
            type: String,
            default: 'rentals'
        },
        pageSlug: {
            type: String,
            default: 'rental'
        }
    },
    data: function () {
        return {
            itemsCount: 0,
        }
    },
    computed: {
        ...mapGetters('app', ['settings']),
        tableTimeOptions() {
            return JSON.parse(this.$mixTableTimeOptions);
        },
    },
    methods: {
        getTimeOptionById(id) {
            if(!this.type.time_options_price.length){
                return {};
            }
            const timeOptions = this.type.time_options_price.find(i => i.price_id === id);

            if(!timeOptions){
                return {};
            }

            const location = this.type.bike_location.find(i => i.location_id === this.settings.location.id);

            if(!location){
                return {
                    ...timeOptions,
                    final_price: timeOptions.price
                };
            }

            return {
                ...timeOptions,
                final_price: timeOptions.price - (timeOptions.price * (location.discount / 100))
            };
        }
    }
}
</script>

<style scoped>

</style>
